module.exports = __webpack_public_path__ + "static/media/MZ.54adf515.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/MZ.svg
// module id = 325
// module chunks = 0